// @ts-nocheck
(function () {
  "use strict";

  const path = window.location.pathname;
  const isProduct = path.includes("/products/");
  const isCollection = path.includes("/collections/") && !isProduct;

  if (!isProduct && !isCollection) return;

  const MENU_SELECTORS = [
    { selector: ".header__yellow-nav .header__nav-link[href]", activeClass: "active" },
    { selector: ".header__yellow-nav .header__nav-dropdown-link[href]", activeClass: "active" },
    { selector: ".menu-list__list .menu-list__link[href]", activeClass: "menu-list__link--active" },
    { selector: ".overflow-dropdown .overflow-dropdown-link[href]", activeClass: "overflow-dropdown-link--active" },
  ];

  const activeLinks = new Set();
  let mainObserver = null;
  const BREADCRUMB_SELECTOR = '.breadcrumbs__list .breadcrumbs__item a.breadcrumbs__link[href*="/collections/"]';

  /**
   * @param {string} url
   */
  function extractHandle(url) {
    const match = url?.match(/\/collections\/([^\/\?#]+)/);
    return match ? match[1] : null;
  }

  /**
   * @param {string} handle
   */
  function findMenuMatch(handle) {
    if (!handle) return false;
    const collectionPath = `/collections/${handle}`;
    for (const { selector } of MENU_SELECTORS) {
      if (document.querySelector(`${selector}[href*="${collectionPath}"]`)) return true;
    }
    return false;
  }

  /**
   * Gets breadcrumbs for product pages (cached query)
   * @returns {NodeList}
   */
  function getBreadcrumbs() {
    return document.querySelectorAll(BREADCRUMB_SELECTOR);
  }

  /**
   * Checks if breadcrumbs are ready on product pages
   * @returns {boolean}
   */
  function areBreadcrumbsReady() {
    return !isProduct || getBreadcrumbs().length > 0;
  }

  function getTargetHandle() {
    if (isProduct) {
      // For product pages, ensure breadcrumbs are ready first
      if (!areBreadcrumbsReady()) return null;
      
      const breadcrumbs = getBreadcrumbs();
      for (const link of breadcrumbs) {
        const href = link.getAttribute("href");
        if (!href) continue;
        const handle = extractHandle(href);
        if (handle && findMenuMatch(handle)) return handle;
      }
      return null;
    }

    const urlHandle = extractHandle(path);
    if (urlHandle && findMenuMatch(urlHandle)) return urlHandle;

    const wrapper = document.querySelector(".ud-collection-wrapper[parent-collection]");
    const parentHandle = extractHandle(wrapper?.getAttribute("parent-collection") ?? "");
    return parentHandle && findMenuMatch(parentHandle) ? parentHandle : null;
  }

  /**
   * @param {HTMLElement} link
   * @param {string} activeClass
   */
  function protectActiveClass(link, activeClass) {
    if (activeLinks.has(link)) return;
    activeLinks.add(link);
    new MutationObserver(() => {
      if (!link.classList.contains(activeClass)) link.classList.add(activeClass);
    }).observe(link, { attributes: true, attributeFilter: ["class"] });
  }

  /**
   * @param {string} handle
   */
  function applyActiveState(handle) {
    if (!handle) return;
    const collectionPath = `/collections/${handle}`;

    for (const { selector, activeClass } of MENU_SELECTORS) {
      document.querySelectorAll(selector).forEach((link) => {
        if (!(link instanceof HTMLElement)) return;
        if (link.getAttribute("href")?.includes(collectionPath) && !activeLinks.has(link)) {
          requestAnimationFrame(() => {
            link.classList.add(activeClass);
            protectActiveClass(link, activeClass);
          });
        }
      });
    }
  }

  /**
   * Sets up the main MutationObserver for ongoing DOM changes
   */
  function setupMainObserver() {
    if (mainObserver) return; // Already set up
    
    mainObserver = new MutationObserver(() => {
      const currentHandle = getTargetHandle();
      if (currentHandle) {
        requestAnimationFrame(() => applyActiveState(currentHandle));
      }
    });
    mainObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Waits for breadcrumbs to be ready on product pages, then applies active state
   * @param {number} maxAttempts - Maximum number of attempts to check for breadcrumbs
   * @param {number} attempt - Current attempt number
   */
  function waitForBreadcrumbsAndApply(maxAttempts = 50, attempt = 0) {
    // For product pages, wait for breadcrumbs to be ready
    if (isProduct && !areBreadcrumbsReady()) {
      if (attempt < maxAttempts) {
        requestAnimationFrame(() => waitForBreadcrumbsAndApply(maxAttempts, attempt + 1));
        return;
      }
      // If breadcrumbs still not ready after max attempts, set up observer to wait
      const breadcrumbObserver = new MutationObserver(() => {
        if (areBreadcrumbsReady()) {
          breadcrumbObserver.disconnect();
          const handle = getTargetHandle();
          if (handle) {
            requestAnimationFrame(() => applyActiveState(handle));
            setupMainObserver();
          }
        }
      });
      breadcrumbObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
      return;
    }

    // Breadcrumbs ready (or not a product page), proceed with normal flow
    const handle = getTargetHandle();
    if (!handle) return;

    requestAnimationFrame(() => applyActiveState(handle));
    setupMainObserver();
  }

  function init() {
    waitForBreadcrumbsAndApply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    requestAnimationFrame(init);
  }
})();
